
import { Button, Dialog, DialogContent, IconButton } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import React, { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { getReferralSourceName } from '../constants/referralSources';
import SiteMap from './SiteMap';


const MapSite = () => {
  const navigate = useNavigate();
  const { referralSource } = useParams();
  const referralName = getReferralSourceName(referralSource);
  const [openModal, setOpenModal] = useState(false);
  const [selectedImage, setSelectedImage] = useState('');

  const handleImageClick = (imageSrc: string) => {
    setSelectedImage(imageSrc);
    setOpenModal(true);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
    setSelectedImage('');
  };

  return (
    <>
    <div className="app-banner">
      <div className="hfb-logo">
        <a
          target="_blank"
          rel="noopener noreferrer"
          href="https://www.houstonfoodbank.org/upcomingevent/share-your-holidays/"
        >
          <img alt="hfb-logo" src="../images/hfb_logo.png" />
        </a>
      </div>
      <div className="sponsor-logo-wrapper">
        <img
          alt="sponsor-partner-1"
          style={{marginInline: 25, height: 120, objectFit: 'contain', cursor: 'pointer'}}
          src="../images/sponsor_partner_1.png"
          onClick={() => handleImageClick('../images/sponsor_partner_1.png')}
        />
        <img
          alt="sponsor-partner-2"
          style={{marginInline: 25, height: 120, objectFit: 'contain', cursor: 'pointer'}}
          src="../images/sponsor_partner_2.png"
          onClick={() => handleImageClick('../images/sponsor_partner_2.png')}
        />
      </div>
      <div className="action-wrapper">
        <Button
          target="_blank"
          href="https://www.houstonfoodbank.org/upcomingevent/share-your-holidays/"
          color="secondary"
          variant="outlined"
        >
          Learn More
        </Button>
      </div>
      <div className="action-wrapper">
        <Button
          color="secondary"
          variant="outlined"
          onClick={() => navigate('/admin/pantryList')}
        >
          Admin
        </Button>
      </div>
    </div>
    {referralName && (
      <div
        style={{
          position: 'fixed',
          bottom: 24,
          left: '50%',
          transform: 'translateX(-50%)',
          zIndex: 1,
          pointerEvents: 'none',
          backgroundColor: 'rgba(255, 255, 255, 0.9)',
          border: '1px solid #e5e5e5',
          borderRadius: 4,
          padding: '4px 12px',
          fontSize: 14,
          boxShadow: '0px 2px 10px 1px rgba(0, 0, 0, 0.2)',
        }}
      >
        Referred by / Referido por:&nbsp;<span className="notranslate">{referralName}</span>
      </div>
    )}
    <SiteMap />

    <Dialog
      open={openModal}
      onClose={handleCloseModal}
      maxWidth="md"
      fullWidth
    >
      <DialogContent style={{position: 'relative', padding: 0}}>
        <IconButton
          onClick={handleCloseModal}
          style={{
            position: 'absolute',
            right: 8,
            top: 8,
            backgroundColor: 'rgba(255, 255, 255, 0.9)',
            zIndex: 1
          }}
        >
          <CloseIcon />
        </IconButton>
        <img
          src={selectedImage}
          alt="sponsor-partner-full"
          style={{
            width: '100%',
            height: 'auto',
            display: 'block'
          }}
        />
      </DialogContent>
    </Dialog>
    </>
  );
};

export default MapSite;
